// extracted by mini-css-extract-plugin
export var moreLink = "MenuItemHeadline-module--moreLink--f7463";
export var root = "MenuItemHeadline-module--root--1c388";
export var textWrap = "MenuItemHeadline-module--textWrap--51254";